import { useEffect, useRef, useState } from 'react';
import styles from './filterHeader.module.css';
import { ReactComponent as Arrow } from '../../assets/icons/trvto_arrowRightWhite.svg';

const FilterHeader = ({
    title,
    subtitle,
    filters = [],
    selectedFilter,
    onFilterChange,
    sortOptions = [],
    selectedSort,
    onSortChange,
    type,
    searchEndRef
}) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [showArrow, setShowArrow] = useState(false);

    const scrollRef = useRef(null);

    /* -----------------------------------------
       CITY HORIZONTAL SCROLL
    ----------------------------------------- */
    useEffect(() => {
        const container = scrollRef.current;

        if (!container) return;

        const checkScroll = () => {
            const hasMore = container.scrollLeft + container.clientWidth < container.scrollWidth - 5;

            setShowArrow(hasMore);
        };

        checkScroll();

        container.addEventListener('scroll', checkScroll);
        window.addEventListener('resize', checkScroll);

        return () => {
            container.removeEventListener('scroll', checkScroll);
            window.removeEventListener('resize', checkScroll);
        };
    }, [filters]);

    /* -----------------------------------------
       CITY SCROLL RIGHT
    ----------------------------------------- */
    const scrollRight = () => {
        scrollRef.current?.scrollBy({
            left: 220,
            behavior: 'smooth'
        });
    };

    /* -----------------------------------------
       STICKY HEADER
       
       Desktop:
       - No sticky city bar

       Mobile:
       - Becomes sticky after 230px
       - Stops when search results end
    ----------------------------------------- */
    useEffect(() => {
        const handleScroll = () => {
            // Sticky behavior only on mobile
            if (window.innerWidth > 768) {
                setIsScrolled(false);
                return;
            }

            const scrollTop = window.scrollY;
            const triggerPoint = 230;

            // Position of the end of search results
            const searchEndTop = searchEndRef?.current?.getBoundingClientRect().top ?? Infinity;

            /*
             * 120px = approximate space occupied by
             * sticky Filter + Cities area.
             */
            const shouldStick = scrollTop > triggerPoint && searchEndTop > 120;

            setIsScrolled(shouldStick);
        };

        handleScroll();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, [searchEndRef]);

    /* -----------------------------------------
       CITY CHANGE
    ----------------------------------------- */
    const handleCityChange = (city) => {
        const newValue = selectedFilter === city ? null : city;

        onFilterChange(newValue);

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div className={`${styles.container} ${isScrolled ? styles.scrlContainer : ''}`}>
            {/* =====================================
                TITLE
            ===================================== */}
            <div className={`${styles.headerTop} ${isScrolled ? styles.hideHeader : ''}`}>
                <div>
                    <h2 className={styles.title}>{title}</h2>

                    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                </div>
            </div>

            {/* =====================================
                CITIES
            ===================================== */}
            {type === 'trip' && (
                <div className={`${styles.filterWrapper} ${isScrolled ? styles.scrlFilterWrapper : ''}`}>
                    <div className={styles.cityTitle}>Start Cities :</div>

                    <div className={styles.filterContainer} ref={scrollRef}>
                        {filters.map((filter) => (
                            <button
                                key={filter.name}
                                type='button'
                                className={`${styles.chip} ${selectedFilter === filter.name ? styles.activeChip : ''}`}
                                onClick={() => handleCityChange(filter.name)}
                            >
                                {filter.name}
                            </button>
                        ))}

                        {showArrow && (
                            <div onClick={scrollRight} className={styles.arrowBtn}>
                                <Arrow />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FilterHeader;
